<template>
	<div class="row">
		<div class="col-12">
			<b-card :title="title">
				<div style="margin-left: -1.5rem;margin-right: -1.5rem;">
					<!-- 表格 -->
					<b-table ref="refUserListTable" class="position-relative" :items="tableData" responsive
						:fields="tableColumns" primary-key="id" show-empty :empty-text="!loading ? '暂无数据' : '数据加载中...'"
						:no-provider-paging="false" stacked="md">
						<template v-slot:cell(app_scope_status)="data">
							<b-badge v-if="data.value===''||data.value===null" href="javascript:void(0)"
								variant="primary">未开通</b-badge>
							<b-badge v-else-if="data.value===0" href="javascript:void(0)" variant="warning">待审批
							</b-badge>
							<b-badge v-else-if="data.value===2" href="javascript:void(0)" variant="danger">审批拒绝
							</b-badge>
							<b-badge v-else-if="data.value===1" href="javascript:void(0)"
								variant="success">已开通</b-badge>
							<b-badge v-else href="javascript:void(0)">未知</b-badge>
						</template>
						<template v-slot:cell(actions)="data">
							<div style="min-width: 11rem;">
								<a v-if="data.item.app_scope_status===''||data.item.app_scope_status===null"
									class="mr-1" href="javascript:void(0)" @click="open(data)">开通权限</a>
								<a v-if="data.item.app_scope_status===1" class="mr-1" href="javascript:void(0)"
									@click="close(data)">关闭权限</a>
								<a v-if="data.item.app_scope_status===0" class="mr-1" href="javascript:void(0)"
									@click="close(data)">撤回权限</a>
							</div>
						</template>
					</b-table>
				</div>
			</b-card>
		</div>
	</div>
</template>

<script>
	import {
		BCard,
		BButton,
		BFormGroup,
		BFormInput,
		BFormCheckbox,
		BIcon,
		BSpinner,
		BTable,
		BBadge,
		BAlert
	} from 'bootstrap-vue'
	export default {
		components: {
			BCard,
			BButton,
			BFormGroup,
			BFormInput,
			BFormCheckbox,
			BIcon,
			BSpinner,
			BTable,
			BBadge,
			BAlert
		},
		data() {
			return {
				id: '',
				name: '',
				tableData: [],
				title: "权限管理",
				loading: false,
				id: undefined,
				tableColumns: [{
						key: "busines_name",
						label: "分类",
						sortable: true
					},
					{
						key: "name",
						label: "权限名称",
						sortable: true
					},
					{
						key: "detail",
						label: "描述",
						sortable: true
					},
					{
						key: "app_scope_status",
						label: "状态",
						sortable: true
					},
					{
						key: "actions",
						label: "操作",
					},
				],
			}
		},
		created() {
			this.id = this.$route.params.id;
			this.name = this.$route.query.name;
			this.title = `${this.name} 权限管理`
			if (this.$route.name == this.OperateRouterName) {
				this.showDetail = true;
			}
			this.loadData();
		},
		methods: {
			loadData() {
				this.tableData = [];
				this.loading = true;
				this.$http
					.get("/App/GetAppScopes", {
						params: {
							id: this.id,
						}
					})
					.then((u) => {
						this.loading = false;
						this.tableData = u;
					})
					.catch((u) => {
						this.loading = false;
					});
			},
			open(data) {
				this.$http.get('/App/AddAppScope', {
					params: {
						app_id: this.id,
						scope_id: data.item.id,
						status: 3
					}
				}).then(u => {
					this.loadData();
					this.$alertSuccess('开通成功');
				})
			},
			close(data) {
				this.$http.get('/App/DeleteAppScope', {
					params: {
						app_id: this.id,
						scope_id: data.item.id
					}
				}).then(u => {
					this.loadData();
					this.$alertSuccess('关闭成功');
				})
			}
		}
	}
</script>

<style>
</style>